const {
  GRADE_TYPES: {
    FREE_FORM,
    PERCENTAGE,
    RUBRIC,
    PASS_FAIL,
    LETTER_GRADE,
    POINTS,
  },
  PASS_FAIL_ITEMS,
  LETTER_GRADES,
} = require('./constants');

const getGradeForDisplay = ({ gradeType, grade, rubricGradeType, maxGrade }) => {
  if (grade === null || grade === undefined || grade === '') {
    return '';
  }

  switch (gradeType) {
  case PERCENTAGE:
    return `${grade}%`;

  case RUBRIC:
    if (rubricGradeType === PERCENTAGE) {
      return `${grade}%`;
    }
    return String(grade);

  case PASS_FAIL:
    return PASS_FAIL_ITEMS[grade] || '';

  case LETTER_GRADE:
    if (LETTER_GRADES.includes(grade)) {
      return grade;
    }
    return '';
  case POINTS:
    if (!maxGrade) return '';
    return `${grade}/${maxGrade}`;

  case FREE_FORM:
  default:
    return String(grade);
  }
};

module.exports = getGradeForDisplay;
